/**
 * <MediaCenterInput 
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './MediaCenterInput.scss';
import MediaCenterModal from 'template/Modals/MediaCenter';
import locale from './locale';

class MediaCenterInput extends React.Component {
  constructor(props) {
    super(props);
  
    this.openMediaCenterInput = this.openMediaCenterInput.bind(this);
  }

  componentWillMount() {

  }

  openMediaCenterInput() {
    const {
      selectMultiple,
      onChange,
    } = this.props; 
    
    MediaCenterModal({
      selectMultiple,
    })
      .then((images = [])=>{
        if (images.length > 0) {
          if (selectMultiple) {
            onChange(images);
          } else {
            onChange(images[0]);
          }
        }
      });
  }
  
  render() {
    const {
      value,
      onChange,
    } = this.props;

    let images = [];
    if (value) {
      if (Array.isArray(value)) {
        images = value;
      } else {
        images = [value];
      }
    }

    return (
      <div className='MediaCenterInput'>
        <ul class='MediaCenterInput--thumbnail--list'>
          { images.map((src = {})=>{
              return (
                <li className='MediaCenterInput--thumbnail'>
                  <img src={src.thumbnail_url || src.original_url} /> 
                </li>
              )
            })
          }
        </ul>
        <button className='btn btn-primary' onClick={this.openMediaCenterInput}>{__('Add Image', locale)}</button>
      </div>
    )
  }
}

export default MediaCenterInput;



// WEBPACK FOOTER //
// ./src/components/Form/Fields/MediaCenter/index.js